(function () {
    "use strict";

    angular
        .module("app")
        .directive("salesForecastGrid", ["$filter", "GridUtil", "ForecastingService", "PermissionService", salesForecastGrid]);

    function salesForecastGrid($filter, gridUtil, forecastingService, permissionService) {
        return {
            restrict: "E",
            link: function (scope, element) {

                scope.loadGrid = function () {

                    if (!scope.prototypeId || !scope.seasonId || scope.readOnly === undefined) {
                        return;
                    }

                    var params = { prototypeId: scope.prototypeId, seasonId: scope.seasonId };

                    forecastingService.searchSalesForecast(params).then(function (results) {
                        scope.data = results.results;
                        scope.createGridColumns(results);
                        scope.setWindowGridHeight();
                        scope.gridOptions.api.setRowData(results.results);
                        scope.canRecalc = true;
                    });

                    forecastingService.getSalesForecastCurrencies(scope.prototypeId, scope.seasonId).then(function (currencies) {
                        scope.currencies = currencies;
                    });
                };

                scope.reloadFunc = function () {
                    scope.loadGrid();
                };

                scope.createGridColumns = function (results) {
                    var columnDefs = [
                        { field: "SalesRegionName", headerName: "Region", width: 150, menuTabs: [] }
                    ];

                    var added = {};

                    var hasPermissions = permissionService.canEditQuarterlyForecasting();

                    _.each(results.results, function (r) {
                        _.each(r.DynamicColumns, function (c) {
                            if (!added[c.headerName]) {
                                columnDefs.push({
                                    field: c.field,
                                    headerName: c.headerName,
                                    editable: (c.editable && hasPermissions && scope.readOnly !== true),
                                    cellRenderer: c.cellRenderer ? (scope.renderers[c.cellRenderer] || gridUtil[c.cellRenderer]) : null,
                                    cellEditor: c.cellEditor ? gridUtil[c.cellEditor] : null,
                                    width: c.width,
                                    menuTabs: []
                                });
                                added[c.headerName] = 1;
                            }
                        });
                    });

                    scope.gridOptions.api.setColumnDefs(columnDefs);
                };

                scope.recalculate = function () {
                    forecastingService.calculateSalesForecastRevenue(scope.prototypeId, scope.seasonId, scope.recalcPrice).then(function (data) {

                        scope.gridOptions.api.forEachNode(function (node) {
                            _.each(data, function (d) {
                                if (d.SalesRegionId === node.data.SalesRegionId) {

                                    var field = null;
                                    if (node.data.Year1 === d.Year) {
                                        field = "Year1Quarter" + d.Quarter + "Revenue";
                                    }
                                    else if (node.data.Year2 === d.Year) {
                                        field = "Year2Quarter" + d.Quarter + "Revenue";
                                    }

                                    if (field && node.data.hasOwnProperty(field))
                                        node.data[field] = d.Revenue;
                                }
                            });
                        });

                        scope.gridOptions.api.refreshCells({ force: true });

                    });
                }

                scope.setWindowGridHeight = function () {
                    if (window.outerHeight >= 768) {
                        scope.windowGridHeight = window.innerHeight - 400;
                    } else if (scope.pagerData) {
                        var size = scope.pagerData.TotalRecords < scope.pagerData.PageSize ? scope.pagerData.TotalRecords : scope.pagerData.PageSize;
                        scope.windowGridHeight = (size * scope.gridOptions.rowHeight) + 46;
                    } else {
                        scope.windowGridHeight = 5 * scope.gridOptions.rowHeight;
                    }
                };

                scope.init = function () {

                    scope.renderers = {
                        currency: function (params) {
                            return $filter("currency")(params.value, $filter("currencySymbol")(params.data));
                        }
                    };

                    scope.gridOptions = {
                        columnDefs: null,
                        defaultColDef: {
                            resizable: true
                        },
                        rowHeight: 30,
                        enableColResize: true,
                        enableFilter: false,
                        enableSorting: false,
                        enableServerSideSorting: false,
                        suppressContextMenu: true,
                        suppressMultiSort: true,
                        suppressSorting: true,
                        suppressDragLeaveHidesColumns: true,
                        suppressMovableColumns: true,
                        suppressRowHoverClass: true,
                        suppressColumnMoveAnimation: true,
                        suppressColumnVirtualisation: true,
                        showToolPanel: false,
                        stopEditingWhenGridLosesFocus: true,
                        onCellValueChanged: function (params) {
                            var quarterYearRegex = /(20[0-9]{2}).Q([1-4])/g;

                            var match = quarterYearRegex.exec(params.colDef.headerName);

                            if (match.length > 2) {
                                var prototypeId = params.data.PrototypeId;
                                var seasonId = params.data.SeasonId;
                                var salesRegionId = params.data.SalesRegionId;
                                var year = parseInt(match[1]);
                                var quarter = parseInt(match[2]);
                                var pairs = parseInt(params.newValue);
                                if (isNaN(pairs)) pairs = 0;

                                if (pairs === parseInt(params.oldValue))
                                    return;

                                forecastingService.updateSalesForecastPairs(prototypeId, seasonId, salesRegionId, year, quarter, pairs).then(function (data) {
                                    var colToUpdate = params.colDef.field.replace("Pairs", "Revenue");

                                    params.data[colToUpdate] = data;

                                    scope.gridOptions.api.updateRowData({
                                        update: [params.data]
                                    });

                                    scope.gridOptions.api.refreshCells({ force: true });
                                });
                            }
                        }
                    };

                    var gridDiv = angular.element(element).children()[1];
                    new agGrid.Grid(gridDiv, scope.gridOptions);

                    scope.$watchGroup(["prototypeId", "seasonId", "readOnly"], function () {
                        if (scope.prototypeId && scope.seasonId) {
                            scope.loadGrid();
                        }
                    });

                    scope.$watch("recalcPrice", function () {
                        if (scope.canRecalc && scope.recalcPrice) {
                            scope.recalculate();
                        }
                    });
                };

                scope.init();

            },
            scope: { prototypeId: "=", seasonId: "=", recalcPrice: "=?", reloadFunc: "=?", readOnly: "=" },
            templateUrl: templateUrl("app/directives/salesForecast/salesForecastGrid.directive.html")
        };
    }
})();

